import { Routes } from '@angular/router';
import { BadgesService } from '~/routes/_/badges/badges.service';
import { CompaniesService } from '~/routes/_/companies/companies.service';
import { DevicesService } from '~/routes/_/devices/devices.service';
import { UsersService } from '~/routes/_/users/users.service';
import { AuthService } from '~/routes/auth/auth.service';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('~/routes/_/container.component').then(m => m.ContainerComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'companies',
      },
      {
        path: 'companies',
        providers: [CompaniesService],
        loadChildren: () => import('~/routes/_/companies/companies.routes').then(m => m.companiesRoutes),
      },
      {
        path: 'devices',
        providers: [DevicesService],
        loadChildren: () => import('~/routes/_/devices/devices.routes').then(m => m.devicesRoutes),
      },
      {
        path: 'badges',
        providers: [BadgesService],
        loadChildren: () => import('~/routes/_/badges/badges.routes').then(m => m.badgesRoutes),
      },
      {
        path: 'users',
        providers: [UsersService],
        loadChildren: () => import('~/routes/_/users/users.routes').then(m => m.usersRoutes),
      },
    ],
  },
  {
    path: 'auth',
    providers: [AuthService],
    loadChildren: () => import('~/routes/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'companies',
  },
];
